<template>
  <div id="Catalog" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <div class="cataTop">
      <div>公司基本信息</div>
      <div>截止日期：2019/12/10</div>
    </div>
    <div class="cataform">
      <el-form :model="infoData" status-icon :rules="infoRule" ref="infoData" label-width="200px" class="demo-ruleForm">
        <!-- <el-form-item label="上传公司logo" required>
          <input class="fileInput" @change="chooseImg" name="file" id="file" type="file" ref="file" accept="image/*" />
          <label for="file" class="fileLabel">选择图片</label>
          <el-button type="primary">上传图片</el-button>
        </el-form-item> -->
        <el-form-item label="公司中文名" prop="ClgComName">
          <el-input v-model="infoData.ClgComName" placeholder="请输入公司中文名"></el-input>
        </el-form-item>
        <el-form-item label="公司英文名" prop="ClgComEName">
          <el-input v-model="infoData.ClgComEName" placeholder="请输入公司中文名"></el-input>
        </el-form-item>
        <el-form-item label="展位号" prop="ClgBthCode">
          <el-input v-model="infoData.ClgBthCode" placeholder="请输入展位号"></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="ClgTel">
          <div class="faxOrTel">
            <el-input v-model="coutrycode" class="faxOrTelInput1"></el-input>
            <el-input v-model="citycode" class="faxOrTelInput12"></el-input>
            <el-input v-model="infoData.ClgTel" :placeholder="'请输入电话'"></el-input>
          </div>
          <!-- <el-input v-model="infoData.ClgTel" placeholder='请输入电话'></el-input> -->
        </el-form-item>
        <el-form-item label="传真" prop="ClgFax">
          <div class="faxOrTel">
            <el-input v-model="coutrycode" class="faxOrTelInput1"></el-input>
            <el-input v-model="citycode" class="faxOrTelInput12"></el-input>
            <el-input v-model="infoData.ClgTel" :placeholder="'请输入邮箱'"></el-input>
          </div>
          <!-- <el-input v-model="infoData.ClgFax" placeholder='请输入传真'></el-input> -->
        </el-form-item>
        <el-form-item label="邮箱" prop="ClgEmail">
          <el-input v-model="infoData.ClgEmail" placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-form-item label="网站" prop="ClgWebUrl">
          <el-input v-model="infoData.ClgWebUrl" placeholder="请输入网站"></el-input>
        </el-form-item>
        <el-form-item label="公司描述中文" prop="ClgIntro">
          <el-input v-model="infoData.ClgIntro" placeholder="请输入公司描述中文"></el-input>
        </el-form-item>
        <el-form-item label="公司描述英文" prop="ClgEIntro">
          <el-input v-model="infoData.ClgEIntro" placeholder="请输入公司描述英文"></el-input>
        </el-form-item>
        <el-form-item label="中文地址" prop="ClgAddress">
          <el-input v-model="infoData.ClgAddress" maxlength="100" placeholder="请输入中文地址"></el-input>
        </el-form-item>
        <el-form-item label="英文地址" prop="ClgEAddress">
          <el-input v-model="infoData.ClgEAddress" maxlength="100" placeholder="请输入英文地址"></el-input>
        </el-form-item>
        <el-form-item label="邮编" prop="ClgZipCode">
          <el-input v-model="infoData.ClgZipCode" placeholder="请输入邮编"></el-input>
        </el-form-item>
        <el-form-item label="会刊联系人手机号" prop="ClgMobile">
          <el-input v-model="infoData.ClgMobile" placeholder="请输入会刊联系人手机号"></el-input>
        </el-form-item>
        <el-form-item label="会刊联系人" prop="ClgLinkMan">
          <el-input v-model="infoData.ClgLinkMan" placeholder="请输入会刊联系人"></el-input>
        </el-form-item>
        <!-- <div v-for="(item, index) in formdata" :key="index">
          <el-form-item  v-if="item.name!=='ClgTel'&&item.name!=='ClgFax'" :label="item.title" :required="item.required">
            <el-input v-model="item.value" :disabled="item.name=='ClgBthCode'" :placeholder="'请输入'+item.title"></el-input>
          </el-form-item>
          <el-form-item  v-if="item.name=='ClgTel'" :label="item.title" :required="item.required">
            <div class="faxOrTel">
              <el-input v-model="coutrycode" class="faxOrTelInput1"></el-input>
              <el-input v-model="citycode" class="faxOrTelInput12"></el-input>
              <el-input v-model="item.value" :disabled="item.name=='ClgBthCode'" :placeholder="'请输入'+item.title"></el-input>
            </div>
          </el-form-item>
          <el-form-item  v-if="item.name=='ClgFax'" :label="item.title" :required="item.required">
            <div class="faxOrTel">
              <el-input v-model="coutrycode" class="faxOrTelInput1"></el-input>
              <el-input v-model="citycode" class="faxOrTelInput12"></el-input>
              <el-input v-model="item.value" :disabled="item.name=='ClgBthCode'" :placeholder="'请输入'+item.title"></el-input>
            </div>
          </el-form-item>
        </div> -->
      </el-form>
      <div class="cataBtnbox"><el-button type="primary" @click="onSubmit('infoData')">保存</el-button></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    status: {
      type: Boolean,
      require: true
    }
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入公司中文名称'))
      } else {
        if (this.infoData.ClgComName !== '') {
          this.$refs.infoData.validateField('ClgComName')
        }
        callback()
      }
    }
    const { ComNameCn, ComNameEn, Tel, Email, descCn, descEn, addressCn, addressEn, ZipCode, Mobile, Name, webUrl } = this.$store.state.reg
    return {
      infoData: {
        ClgComName: '',
        ClgComEName: '',
        ClgBthCode: '',
        ClgTel: '',
        ClgFax: '',
        ClgEmail: '',
        ClgWebUrl: '',
        ClgIntro: '',
        ClgEIntro: '',
        ClgAddress: '',
        ClgEAddress: '',
        ClgZipCode: '',
        ClgMobile: '',
        ClgLinkMan: ''
      },
      // formdata:[
      //   {name:'ClgComName', value:'', optionnal:true, required: true, title:'公司中文名称'},
      //   {name:'ClgComEName', value:'', optionnal:true, required: true,title:'公司英文名称'},
      //   {name:'ClgBthCode', value:'', optionnal:true, required: true,title:'展位号'},
      //   {name:'ClgTel', value:'', optionnal:true, required: true,title:'电话'},
      //   {name:'ClgFax', value:'', optionnal:true, required: true,title:'传真'},
      //   {name:'ClgEmail', value:'', optionnal:true, required: true,title:'邮箱'},
      //   {name:'ClgWebUrl', value:'', optionnal:true, required: true,title:'网站'},
      //   {name:'ClgIntro', value:'', optionnal:true, required: true,title:'公司描述中文'},
      //   {name:'ClgEIntro', value:'', optionnal:true, required: true,title:'公司描述英文'},
      //   {name:'ClgAddress', value:'', optionnal:true, required: true,title:'中文地址'},
      //   {name:'ClgEAddress', value:'', optionnal:true, required: true,title:'英文地址'},
      //   {name:'ClgZipCode', value:'', optionnal:true, required: true,title:'邮编'},
      //   {name:'ClgMobile', value:'', optionnal:true, required: true,title:'会刊联系人手机号'},
      //   {name:'ClgLinkMan', value:'', optionnal:true, required: true,title:'会刊联系人'},
      // ],
      infoRule: {
        ClgComName: [
          { required: true, message: '请输入公司中文的名称', trigger: 'blur' },
          { pattern: ComNameCn, message: '格式错误' }
        ],
        ClgComEName: [{ pattern: ComNameEn, message: '格式错误' }],
        ClgTel: [{ pattern: Tel, message: '格式错误' }],
        ClgFax: [{ pattern: Tel, message: '格式错误' }],
        ClgEmail: [{ pattern: Email, message: '格式错误' }],
        ClgWebUrl: [{ pattern: webUrl, message: '格式错误' }],
        ClgIntro: [{ pattern: descCn, message: '格式错误' }],
        ClgEIntro: [{ pattern: descEn, message: '格式错误' }],
        ClgAddress: [{ pattern: addressCn, message: '格式错误' }],
        ClgEAddress: [{ pattern: addressEn, message: '格式错误' }],
        ClgZipCode: [{ pattern: ZipCode, message: '格式错误' }],
        ClgMobile: [{ pattern: Mobile, message: '格式错误' }],
        ClgLinkMan: [{ pattern: Name, message: '格式错误' }]
      },
      coutrycode: '', //国家码
      citycode: '', //城市码
      loading: false
    }
  },
  created() {
    this.init()
  },
  watch: {},
  methods: {
    init() {},
    onSubmit() {
      //验证各项信息
      this.$refs.infoData.validate((valid) => {
        if (valid) {
          alert('submit!')
        } else {
          this.$notify({
            title: '请检查表单填写项是否符合规范！',
            type: 'error'
          })
          return false
        }
      })
    },
    // 选择图片
    chooseImg() {
      let imgData = new FormData()

      let _that = this
      //上传图片宽高处理
      let fileData = this.$refs.file.files[0]
      let reader = new FileReader()
      let reData
      reader.onload = (e) => {
        let data = e.target.result
        //加载图片获取图片真实宽度和高度
        let image = new Image()
        image.src = data
        image.onload = () => {
          if (image.width > image.height) {
            reData = { width: 1024, height: 768 }
          } else {
            reData = { height: 1024, width: 768 }
          }
        }
      }
      //解决fileData为undefined，reader报错问题
      if (fileData) {
        reader.readAsDataURL(fileData)
      } else {
        _that.loading = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
#Catalog {
  .cataTop {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #ececec;
    padding: 18px;
  }
  .cataform {
    padding: 30px 300px;
    .fileInput {
      opacity: 0;
      width: 0;
      height: 0;
    }
    .fileLabel {
      display: inline-block;
      color: #409eff;
      border-radius: 5px;
      padding: 0 12px;
      border: 1px solid #409eff;
      margin-right: 12px;
    }
  }
  .contactMsgTitle {
    padding: 30px;
    font-weight: bold;
    font-size: 20px;
    color: #409eff;
  }
  .cataBtnbox {
    text-align: center;
  }
  .faxOrTel {
    display: flex;
    .faxOrTelInput1 {
      width: 120px;
    }
    .faxOrTelInput12 {
      width: 200px;
      margin: 0 10px;
    }
  }
}
</style>
